export default "__VITE_ASSET__DRnDWUNF__"